const JsAccordion = {
	init () {

		/*              __
	                   / _)         
	            .-^^^-/ /          
	        __/       /              
	        <__.|_|-|_|  

	        The Emagine Dinosaur says; "We're adding some additional backwards accordions".          
	    */

	    // FAQ Accordions - to avoid any confusion, these aren't foundation accordions, spec lists that they need to match old site, so they need to use custom markup
	    if ( $('.accordion-faq').length ) {

	    	// Open Accordion
	    	$('.accordion-btn.open').click(function() {
	    		$(this).closest('.accordion-faq-item').find('.accordion-faq-content').removeClass('hide');
	    		$(this).addClass('hide');
			});

	    	// Close Accordion
			$('.accordion-btn.close').click(function() {
	    		$(this).closest('.accordion-faq-item').find('.accordion-faq-content').addClass('hide');
	    		$(this).closest('.accordion-faq-item').find('.accordion-btn.open').removeClass('hide');
			});
	    }
	}
};

export default JsAccordion;


// WEBPACK FOOTER //
// ./src/components/03-ui/accordion/accordion.js